import { ReactNode } from 'react'

import { IColor } from 'utils/types'

import Box from '../../ui/Box'
import Heading from '../../ui/Heading'
import Text from '../../ui/Text'

interface IItem {
  title: string
  content: ReactNode
  color?: IColor
}

const InfoBlock = ({ title, color = 'grey25', content }: IItem) => (
  <div>
    <Text size='sm' color={color}>
      {title}
    </Text>
    <Box padding={[0.375, 0, 0]}>
      <Heading tag='h3' color={color} size='xs'>
        {content}
      </Heading>
    </Box>
  </div>
)

export default InfoBlock
